import React, { useEffect, useState } from 'react';
import { db, collection, query, orderBy, onSnapshot, where, updateDoc, doc } from '../firebase';

const MessageList = ({ accountNumber, selectedFriend }) => {
  const [messages, setMessages] = useState([]);

  // Compute a unique chatId for the conversation
  const chatId =
    accountNumber < selectedFriend
      ? `${accountNumber}_${selectedFriend}`
      : `${selectedFriend}_${accountNumber}`;

  useEffect(() => {
    if (!selectedFriend) return;

    const q = query(
      collection(db, 'messages'),
      where('chatId', '==', chatId),
      orderBy('timestamp')
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const msgs = snapshot.docs.map(docSnap => ({ id: docSnap.id, ...docSnap.data() }));
      setMessages(msgs);

      // For each message where the current user is the receiver and the message is unread,
      // update it to mark it as read.
      msgs.forEach(async (msg) => {
        if (msg.receiverID === accountNumber && !msg.read) {
          try {
            await updateDoc(doc(db, 'messages', msg.id), { read: true });
          } catch (error) {
            console.error("Error marking message as read:", error);
          }
        }
      });
    }, (error) => {
      console.error("Error in message snapshot:", error);
    });

    return () => unsubscribe();
  }, [selectedFriend, accountNumber, chatId]);

  return (
    <div>
      <h3>Messages</h3>
      {messages.length === 0 && <p>No messages yet.</p>}
      {messages.map((msg) => (
        <div key={msg.id} style={{ marginBottom: "10px" }}>
          <p>
            <strong>{msg.senderName}:</strong> {msg.text}
          </p>
          <small>
            {/* If the sender is the current user, assume they always see the message as read */}
            {msg.senderID === accountNumber || msg.read ? "Read" : "Unread"}
          </small>
        </div>
      ))}
    </div>
  );
};

export default MessageList;
